export default (axios, data) => axios.put(`/bill/${data.publicId}`, data);
